import { render, staticRenderFns } from "./ModalDeleteResource.vue?vue&type=template&id=412cb47a&"
import script from "./ModalDeleteResource.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteResource.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports